import React from 'react';

type Props = React.InputHTMLAttributes<HTMLInputElement>;

const Input: React.FC<Props> = ({ className, ...rest }) => {
  const classes = ['ui-input', className].filter(Boolean).join(' ');
  return <input className={classes} {...rest} />;
};

export default Input;
